export const parseCookies = () => {
  const cookieValueArray =
    typeof document !== `undefined` && document.cookie.split('; ')

  if (!cookieValueArray) return null

  let cookieObject = {}

  cookieValueArray &&
    cookieValueArray.forEach(element => {
      let [key, value] = element.split(/[=](.+)/)

      if (value === 'true' || value === 'false') {
        value = value === 'true'
      }
      cookieObject = { ...cookieObject, [key]: value }
    })

  const parseConsent = consentString => {
    const consentArray = decodeURIComponent(consentString)
      .replace(/[{}']/g, '')
      .split(',')

    consentArray.forEach(elem => {
      const keyValuePair = elem.split(':')
      cookieObject[`${keyValuePair[0]}Consent`] = keyValuePair[1]
    })
    Object.entries(cookieObject).forEach(([key, value]) => {
      switch (value) {
        case 'true':
          cookieObject[key] = true
          break
        case 'false':
          cookieObject[key] = false
          break
      }
    })
  }

  cookieObject.CookieConsent && parseConsent(cookieObject.CookieConsent)

  return cookieObject
}
